import { z } from 'zod';
import { BreakOption, EmploymentType } from '@types';

const GetNotWelcomeListItem = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  imageUrl: z.string().optional(),
  infix: z.string(),
  reason: z.string(),
  dateAdded: z.string(),
  departments: z.array(z.string()),
  partnerName: z.string().optional(),
  employmentType: z.nativeEnum(EmploymentType).optional(),
});

export const GetNotWelcomeListResponse = z.array(GetNotWelcomeListItem);

export type NotWelcomeListItem = z.infer<typeof GetNotWelcomeListItem>;

export enum WorkerType {
  FLEXWORKER = 'FLEXWORKER',
  PARTNERWORKER = 'PARTNERWORKER',
}

const GetFlexWorkerForNotWelcomeList = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  infix: z.string().optional().nullable(),
  email: z.string(),
  workerType: z.nativeEnum(WorkerType),
  employmentType: z.nativeEnum(EmploymentType).nullable(),
});

export const GetFlexWorkerForNotWelcomeListResponse = z.array(GetFlexWorkerForNotWelcomeList);
export type FlexWorkerForNotWelcomeList = z.infer<typeof GetFlexWorkerForNotWelcomeList>;

export type GetBreakOptionsResponse = {
  breakOptions: BreakOption[];
};

export type ChangeCompanySettingsPayload = {
  requiresEmployeeContract: boolean;
  requiresEmployeeCertificates: boolean;
  employeeMutableUntilMinutes: number;
  allowShiftStartTimeOverride: boolean;
  allowShiftEndTimeOverride: boolean;
};

export type CompanyThemeColors = {
  primaryColor: string;
  secondaryColor: string;
  primaryAccent: string;
  secondaryAccent: string;
};

export type CompanyThemeLogoFiles = {
  portalLogoWide?: File;
  portalLogoSquare?: File;
};

export type UpdateCompanyThemePayload = {
  colors: CompanyThemeColors;
  logo?: CompanyThemeLogoFiles;
};
